module.exports = __webpack_public_path__ + "static/media/ic-map-marker-blue.37665279.svg";